// extracted by mini-css-extract-plugin
module.exports = {"eventsContainer":"Events_eventsContainer__14xZX"};